export { treatsDogDesktop, treatsDogMobile } from './treatsDog';
export { newProductsDog } from './newProductsDog';
